exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n*[data-v-6a066524] {\n  font-family: Moderat;\n  font-style: normal;\n  font-weight: normal;\n  /* #E4E5E7 */\n}\n", ""]);

// exports
